const sculptures = (state = { items: [] }, { type, items, filter, global }) => {
  switch (type) {
    case 'ITEMS':
      return {
        ...state,
        items,
        global,
      }
    case 'FILTER':
      return {
        ...state,
        filter,
      }
    default:
      return state
  }
}

export default sculptures